export default function TopStrip() {
  return (
    <>
      <div className="top-strip d-none d-md-block">
        <div className="container d-flex justify-content-between align-items-center">
          <span>
            <i className="fa-solid fa-bolt" /> Exclusive discount live on all
            courses this month
          </span>
          <span>
            <a href="mailto:learning2earningsupport@gmail.com">
              <i className="fa-regular fa-envelope" />learning2earningsupport@gmail.com
            </a>
            &nbsp;&nbsp;
            <a href="tel:7004654910">
              <i className="fa-solid fa-phone" /> 7004654910
            </a>
          </span>
        </div>
      </div>
    </>
  );
}
